import { render, staticRenderFns } from "./table_content_section.vue?vue&type=template&id=22ab237c&scoped=true&"
import script from "./table_content_section.vue?vue&type=script&lang=js&"
export * from "./table_content_section.vue?vue&type=script&lang=js&"
import style0 from "./table_content_section.vue?vue&type=style&index=0&id=22ab237c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab237c",
  null
  
)

export default component.exports